module.exports = __webpack_public_path__ + "static/media/rachel_lu.2eb82f2a.png";